export default __webpack_public_path__ + "static/media/burgerWorks.648577da.png";